import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient';
import './EmailConfirmation.css';

/**
 * Landing page for the "confirm your new email" link Supabase sends when a
 * teacher changes their email from Profile Settings (useEmailChange.js).
 * Deliberately separate from EmailConfirmation.jsx (the sign-up flow) —
 * unlike that one, this does NOT insert any teachers/students row and does
 * NOT read pendingRegistration; it only checks that a session exists (the
 * supabase-js client parses the confirmation token from the URL on load)
 * and sends the user back to Profile Settings.
 */
export default function EmailChangeConfirmation() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking'); // checking | success | error

  useEffect(() => {
    const run = async () => {
      let session = null;
      for (let i = 0; i < 20 && !session; i++) {
        const { data } = await supabase.auth.getSession();
        if (data?.session) { session = data.session; break; }
        await new Promise((r) => setTimeout(r, 100));
      }
      setStatus(session ? 'success' : 'error');
    };
    run();
  }, []);

  return (
    <div className="email-confirmation-container">
      <div className="email-confirmation-card">
        {status === 'checking' && (
          <>
            <div className="spinner"></div>
            <h2>Confirming your new email…</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="success-icon">✓</div>
            <h2>Email updated</h2>
            <p>Your new email address is confirmed.</p>
            <button className="retry-button" onClick={() => navigate('/profile-settings')}>
              Back to Profile Settings
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="error-icon">✗</div>
            <h2>Confirmation failed</h2>
            <p>Invalid or expired link. Please request the email change again from Profile Settings.</p>
            <button className="retry-button" onClick={() => navigate('/profile-settings')}>
              Back to Profile Settings
            </button>
          </>
        )}
      </div>
    </div>
  );
}
